import type { ReactNode } from "react";
import type { EventNode, TypedEvent } from "@/shared/lib/componentHierarchy";
import { ComponentHierarchyContext } from "@/shared/ui/component-hierarchy/context";

export function ComponentScope({
  node,
  children,
}: {
  node: EventNode<TypedEvent>;
  children: ReactNode;
}): React.ReactElement {
  return (
    <ComponentHierarchyContext.Provider value={node}>
      {children}
    </ComponentHierarchyContext.Provider>
  );
}
